import { useTranslation } from 'react-i18next'
import { styled } from 'styled-components'

export const CurrencyIconPopoverMore = ({
  reusedImageCount,
  children,
  withReusedImagesBody,
}: {
  reusedImageCount?: number
  children: React.ReactNode
  withReusedImagesBody?: boolean
}) => {
  const { t } = useTranslation()

  const showMore = (reusedImageCount ?? 0) > 0

  return (
    <Root>
      {children}
      {showMore && !withReusedImagesBody ? (
        <Title>
          {t('currency.duplicates.reused-icons')} ({reusedImageCount})
          <br />
          {t('currency.duplicates.see-more')}
        </Title>
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 6px;
  width: min-content;
`

const Title = styled.p`
  color: var(--text-11);

  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  margin: 0;

  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 8px;
`
